export enum ScreenTypes {
  HOME = 'home',
  GAME = 'game',
  WON = 'won',
  LOST = 'lost',
  ALREADY_PLAYED = 'alreadyPlayed',
  ERROR = 'error',
  NEXT = 'next',
  COLLECT = 'collect',
  SINGLEGAME = 'singleGame',
  MULTIGAME = 'multiGame',
}
